import { Popover, Tag, Tooltip } from 'antd';
import { trimName } from '../../utils/trimName';
import { CommentOutlined } from '@ant-design/icons';
import { LOCATION_TYPES } from '../../constants';

type DependenciesTitleProps = {
  name: string;
  comment?: string;
  type?: string;
};

const DependenciesTitle = ({ name, comment, type }: DependenciesTitleProps) => {
  return (
    <>
      <div
        className={`flex justify-center items-center gap-2 ${
          type === LOCATION_TYPES.DISTRIBUTION_CENTER ? 'min-h-[40px]' : ''
        }`}
      >
        <Tooltip title={name} placement="top" className="">
          {trimName(name, 20)}
        </Tooltip>
        {comment && (
          <Popover
            content={comment || 'No comment added'}
            className="text-[#437EF7] popover--max-width"
            title={`${name} - Commentary`}
            trigger="hover"
          >
            <Popover
              content={comment || 'No comment added'}
              title={`${name} - Commentary`}
              className="text-[#437EF7] popover--max-width"
              trigger="click"
            >
              <div>
                <CommentOutlined style={{ fontSize: '18px' }} />
              </div>
            </Popover>
          </Popover>
        )}
      </div>
      {type === LOCATION_TYPES.DISTRIBUTION_CENTER && (
        <div className="w-full font-semibold mt-1.5">
          <Tag color="green">Distribution Center</Tag>
        </div>
      )}
    </>
  );
};

export default DependenciesTitle;
